module.exports = __webpack_public_path__ + "img/4797a8b.jpg";